<template>
  <div id="app">
    <Header id="header"></Header>
    <main id="main">
      <router-view/>   
    </main>
    <Footer id="footer"></Footer> 
  </div>
</template>

<script>
  import Header from '@/components/header'
  import Footer from '@/components/footer'


  export default {
    name: 'App',
    components :{
      Header: Header,
      Footer: Footer
    }
  }
</script>

<style lang="less">

@import "./assets/common.less";

html, body, #app{
  height:100%;
}

#app {
  display: grid;
  grid-template-columns: 12% auto 12%;
  grid-template-rows: auto 1fr auto;
  grid-template-areas: "header header header"
                       ".      main  ."
                       "footer footer footer";

  #header {
    grid-area: header;
    padding-left: 12%;
    padding-right: 12%;
    background: #2ac1b8;
    text-align: center;
    height: 180px;
  }

  #main {
    grid-area: main;
  }

  #footer {
    grid-area: footer;
    padding-left: 12%;
    padding-right: 12%;
  }
 
  // 响应式设置
  @media (max-width: 768px) {
  #app {
      grid-template-columns: 10px auto 10px;

      #header, #footer {
        padding-left: 10px;
        padding-right: 10px;
      }
    }
  }

}  

</style>



// WEBPACK FOOTER //
// src/App.vue